<!-- eslint-disable max-len -->
<template>
  <v-main>
    <v-row>
      <v-col
        cols="12"
        class="d-flex justify-center"
      >
        <v-card
          flat
          outlined
          rounded="lg"
          max-width="1200px"
          min-height="500px"
        >
          <v-row class="mt-8">
            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <div class="text-md-h4 text-h5" :style="textColor">Welcome to Landrum HR Solutions</div>
            </v-col>

            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <div class="text-md-h5 text-h6 font-weight-light text-center px-4">Thank you for allowing Landrum the opportunity to become your PEO partner!</div>
            </v-col>

            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <v-btn
                large
                color="primary"
                @click="moveToStep1"
              >Let's get started!</v-btn>
            </v-col>
          </v-row>

          <v-footer
            color="transparent"
            :absolute="$vuetify.breakpoint.name == 'lg' ? true : false"
          >
            <v-card flat>
              <v-card-text>
                Your company agrees to furnish Landrum HR Solutions certain confidential information relating to payroll, benefits and corporate financial information for the purpose of receiving a proposal for services and benefits. Landrum agrees to hold confidential information in trust and confidence as it shall be used only for stated purpose. Confidential information shall not be disclosed to any employee, consultant or third party without the knowledge and approval of the company.
              </v-card-text>
              <v-divider></v-divider>
              <v-card-text>
                If you have any questions during this process, please reach out to Business Operations at <a href="mailto:businessops@landrumhr.com">businessops@landrumhr.com</a>
              </v-card-text>
            </v-card>
          </v-footer>
        </v-card>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import ProspectPacket from '@/Data/ProspectPacket';
import BenefitsPacket from '@/Data/BenefitsPacket';

export default {
  name: 'BenefitsRegistration',
  data: () => ({
    temp: null,
  }),
  created() {
    this.$store.commit('updateProspectPacket', ProspectPacket);
    this.$store.commit('updateBenefitsPacket', BenefitsPacket);
  },
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
  },
  methods: {
    moveToStep1() {
      this.$store.dispatch('GetProspectPacket').then(() => {
        if (this.$store.state.prospectPacket.contacts.length === 0) {
          this.$store.commit('updateProspectContacts', ProspectPacket.contacts);
        }
        const { step } = this.$store.state.prospectPacket.state;
        this.$store.dispatch('GetBenefitsPacket').then(() => {
          const bStep = this.$store.state.benefitsPacket.state.step;
          this.$store.commit('benefitsGoToStep', bStep);
        });
        if (this.$store.state.prospectPacket.state.status !== 'Signed') {
          this.$store.commit('updateProspectStateStatus', 'In Progress');
        }
        this.$store.commit('goToStep', step);
      });
    },
  },
};
</script>

<style>

</style>
